require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./global-supply-chain-management-gscm-2-4-0-1.json") })
        }
      }, "path---global-supply-chain-management-gscm-2-4-0-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---global-supply-chain-management-gscm-2-4-0-1!./.cache/json/global-supply-chain-management-gscm-2-4-0-1.json
// module id = 443
// module chunks = 231608221292675